import atoms from '../../../atoms'
import { FiEdit } from 'react-icons/fi'
import { RolesProps, TableRole } from './interface'
const { Table, Button } = atoms

const Index = ({ rolesList, handleEdit, handleAdd }: RolesProps) => {

    const columns = [
        { name: 'Role', selector: (row: TableRole) => row.role_name, sortable: true },
        { name: 'Action', selector: (row: TableRole) => row.action, },
    ]
    return (
        <div>
            <div className="row">
                <div className="col-6">
                </div>
                <div className="col-6 text-end">
                    <Button name={"Add Role"}
                        className=''
                        onClick={() => handleAdd()}
                    />
                </div>
            </div>
            <div>
                <Table columns={columns}
                    data={rolesList?.data?.map((item) => {
                        return ({
                            ...item,
                            action:
                                <Button className="table-edit-button fs-14 fw-400" onClick={() => handleEdit(item?.id)}>
                                    <div className='d-flex align-items-center'>
                                        <FiEdit />
                                        <span className='ms-2 mb-0'>Edit</span>
                                    </div>
                                </Button>
                        })
                    })}
                />
            </div>
        </div>
    )
}

export default Index